import { memo } from "react";
import PropTypes from "prop-types";
import { CustomContainer } from "../DependencyHelper";
import { createMarkup, internalUrl } from "../../../utils/helperServices";
import Image from "../image/image";
import CTAButton from "../CTAButton/CTAButton";
import config from "../../../config/index";
import styles from "./FormRightSidebar.module.scss";
import * as Analytics from "../../../services/analyticsUtag";

const FormRightSidebar = memo(
  ({
    content,
    heading,
    formName,
    pageName,
    pageChannel,
    linkId,
    linkPrevent,
  }) => {
    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;

    const mainHeading = content ? content.title : heading;
    const items = content ? content.items : [];
    const linkButton = content
      ? { title: content.callToActionLabel, href: content.callToActionUri }
      : {};

    const handleClick = (event) => {
      if (linkPrevent) {
        event.preventDefault();
      }

      if (pageName && formName && pageChannel) {
        Analytics.link({
          page_name: `${pageName}`,
          page_channel: `${pageChannel}`,
          page_master_tab: "personal",
          ...Analytics.getUtagData([
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
            "visitor_subscription_type",
          ]),
          link_type: "o",
          link_name: `${pageName}: ${formName}`,
        });
      }
    };

    return (
      <>
        <CustomContainer className={`${styles["container"]}`}>
          <div className={styles["heading"]}>{mainHeading}</div>
          {items.length > 0 && (
            <div className={styles["content"]}>
              {items.map((item, index) => (
                <div key={index} className={styles["item"]}>
                  <Image img_path={item.icon} />
                  <span
                    dangerouslySetInnerHTML={createMarkup(item.description)}
                  ></span>
                </div>
              ))}
            </div>
          )}
          {linkButton?.title && (
            <div className={styles["link-button"]}>
              <CTAButton
                variant="outline grey"
                id={linkId}
                url={linkButton.href ? internalUrl(linkButton.href).url : "#"}
                handleClick={handleClick}
              >
                {linkButton.title}
                <Image
                  img_path={`${imagePrefix}/assets/images/caret-right-blue.svg`}
                />
              </CTAButton>
            </div>
          )}
        </CustomContainer>
      </>
    );
  }
);

FormRightSidebar.defaultProps = {
  heading: "Wondering what to expect?",
  content: {},
  formName: null,
  pageName: null,
  pageChannel: null,
  linkId: "link-cta-btn",
  linkPrevent: false,
};

FormRightSidebar.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.object,
  formName: PropTypes.string,
  pageName: PropTypes.string,
  pageChannel: PropTypes.string,
};

export default FormRightSidebar;
